<template>
  <v-container id="user-profile-view" fluid tag="section">
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading data Laporan Kejadian
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <v-simple-table v-else>
      <template v-slot:default>
        <thead>
          <tr>
            <!-- <th class="text-left">Remarks</th> -->
            <th class="text-left">Tgl</th>
            <th class="text-left">No LK</th>
            <th class="text-left">DeskripsiKejadian</th>
            <th class="text-right">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="remarks in data" :key="remarks.id">
            <td>{{ formatDate(remarks.tgl) }}</td>
            <td>{{ remarks.id }}</td>
            <td>{{ remarks.deskripsi_kejadian }}</td>
            <td class="text-right">
              <v-icon class="mr-2" @click="deleteLaporanKejadian(remarks.id)"
                >mdi-delete</v-icon
              >
              <div class="d-md-none my-5"></div>
              <v-icon @click="openEditModal(remarks.id)">mdi-pencil</v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <EditModal
      :openModal="stateEdit"
      :id="stateEditId"
      @close-modal="closeEditModal"
    />
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "LaporanKejadian",
  data() {
    return {
      stateEdit: false,
      stateEditId: "",
      loading: false,
      data: []
    };
  },
  components: {
    EditModal: () => import("@/components/LaporanKejadian/EditModal.vue")
  },
  methods: {
    async getLaporanKejadian() {
      this.loading = true;

      await axios
        .get(`laporan-kejadian-belum-remarks`)
        .then(res => {
          this.loading = false;
          this.data = res.data;
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async deleteLaporanKejadian(id) {
      this.loading = true;

      await axios
        .delete(`laporan-kejadian/${id}`)
        .then(res => {
          this.loading = false;

          this.getLaporanKejadian();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    openEditModal(id) {
      this.stateEdit = true;
      this.stateEditId = id;
    },
    closeEditModal() {
      this.stateEdit = false;
      this.stateEditId = "";
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    }
  },
  created() {
    this.getLaporanKejadian();
  }
};
</script>
